module.exports = __webpack_public_path__ + "static/img/eredin_destroyer.e2135e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/eredin_destroyer.png
// module id = H2Yk
// module chunks = 0